export const AUTHENTICATION_QUERY_KEY = ['authentication'];

export const GRIPP_WORKSPACE = '00000000-0000-0000-0000-000000000000';